<!-- To use a transparent background with this iframe, use <iframe src="stuff.htm" allowtransparency="true"></iframe> -->
<div class="wrapper" role="main">
  @if (voucherGroup() && !campaignInactive()) {
    <div class="activate-card">
      @if (showHeaderImg()) {
        <div class="imgWrapper">
          <img [src]="townshipImage()" alt="logo" class="logo" />
        </div>
      }
      @if (!voucherGroup().hideVoucherRemainingInfo) {
        <div>
          @if (availableVouchers() > 0) {
            <div class="statistics" role="heading" aria-level="1">
              <div class="subtitle above">
                {{ 'header.subtitle-above' | translate }}
              </div>
              <div class="statistic">{{ availableVouchers() }}</div>
              <div class="subtitle">
                {{ 'header.subtitle-under' | translate: envName() }}
              </div>
            </div>
          }
          @if (availableVouchers() <= 0) {
            <div class="statistics" role="heading" aria-level="1">
              <div class="subtitle above">
                {{ 'no-vouchers.message-above' | translate: envName() }}
              </div>
              <div class="subtitle">
                {{ 'no-vouchers.message-under' | translate }}
              </div>
            </div>
          }
        </div>
      }
      <div class="stepper-container-wrapper">
        <div class="stepper">
          <!-- Step 1: Bedrag -->
          <div class="stepper-item">
            <div
              class="stepper-step"
              [ngClass]="{
                'stepper-active-step': step() >= 1,
                'stepper-inactive-step': step() < 1,
              }"
            >
              @if (step() > 1) {
                ✓
              } @else {
                1
              }
            </div>
            <div class="stepper-label">{{ 'stepper.amount' | translate }}</div>
          </div>

          <div class="stepper-line" [class.active]="step() >= 2"></div>

          <!-- Step 2: Gegevens -->
          <div class="stepper-item">
            <div
              class="stepper-step"
              [ngClass]="{
                'stepper-active-step': step() >= 2,
                'stepper-inactive-step': step() < 2,
              }"
            >
              @if (step() > 2) {
                ✓
              } @else {
                2
              }
            </div>
            <div class="stepper-label">{{ 'stepper.details' | translate }}</div>
          </div>

          @if (extraStepExists()) {
            <div class="stepper-line" [class.active]="step() >= 3"></div>
            <!-- Extra Step -->
            <div class="stepper-item">
              <div
                class="stepper-step"
                [ngClass]="{
                  'stepper-active-step': step() >= 3,
                  'stepper-inactive-step': step() < 3,
                }"
              >
                @if (step() > 3) {
                  ✓
                } @else {
                  3
                }
              </div>
              <div class="stepper-label">{{ 'stepper.extra' | translate }}</div>
            </div>
          }

          <div class="stepper-line" [class.active]="step() >= (extraStepExists() ? 4 : 3)"></div>

          <!-- Step 3 / 4: Betaling -->
          <div class="stepper-item">
            <div
              class="stepper-step"
              [ngClass]="{
                'stepper-active-step': step() >= (extraStepExists() ? 4 : 3),
                'stepper-inactive-step': step() < (extraStepExists() ? 4 : 3),
              }"
            >
              {{ extraStepExists() ? 4 : 3 }}
            </div>
            <div class="stepper-label">{{ 'stepper.payment' | translate }}</div>
          </div>
        </div>
      </div>
      @if (voucherGroup().type === 'sell') {
        <div>
          @if (step() === 1) {
            <form [formGroup]="formStep1" class="step" aria-label="{{ 'buy.aria.step1' | translate }}">
              <div class="step-header">
                <div class="step-header-text">
                  <div class="titles" id="step1Title">{{ 'buy.step1.header' | translate }}</div>
                </div>
              </div>
              <div class="step-container">
                <!-- Left Column: inputs inside card -->
                <div class="step-main-col">
                  <div class="step-card step-1-card">
                    @if (voucherGroup().voucherPrice === 0) {
                      <mat-form-field class="formfield-width-100">
                        <mat-label>{{ 'buy.step1.coupon-value' | translate }}</mat-label>
                        <input
                          formControlName="value"
                          type="number"
                          matInput
                          required
                          autocomplete="off"
                          min="10"
                          max="300"
                          onkeypress="
                            return event.charCode == 8 || event.charCode == 0
                              ? null
                              : event.charCode >= 48 && event.charCode <= 57;
                          "
                        />
                        @if (formStep1.controls.value.errors?.min) {
                          <mat-error>
                            {{ 'errors.minimumBuyVoucherValue' | translate }}
                          </mat-error>
                        }
                        @if (formStep1.controls.value.errors?.max) {
                          <mat-error>
                            {{ 'errors.maximumBuyVoucherValue' | translate }}
                          </mat-error>
                        }
                        @if (formStep1.controls.value.errors?.required) {
                          <mat-error>
                            {{ 'errors.required' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    }
                    <mat-form-field class="formfield-width-100">
                      <mat-label>{{ 'buy.step1.coupon-amount' | translate }}</mat-label>
                      <input
                        formControlName="amount"
                        type="number"
                        matInput
                        required
                        autocomplete="off"
                        min="1"
                        onkeypress="
                          return event.charCode == 8 || event.charCode == 0
                            ? null
                            : event.charCode >= 48 && event.charCode <= 57;
                        "
                      />
                      @if (formStep1.controls.amount.errors?.required) {
                        <mat-error>
                          {{ 'errors.required' | translate }}
                        </mat-error>
                      }
                      @if (formStep1.controls.amount.errors?.min) {
                        <mat-error>
                          {{ 'errors.minimal' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (voucherGroup().useGiftWrapping && voucherGroup().sellType === 'physical') {
                      <mat-checkbox formControlName="giftWrapping" color="primary" class="gift-wrapping-checkbox">
                        {{ 'buy.step1.gift-wrapping' | translate }} (+ €{{
                          getCurrencyString(voucherGroup().giftWrappingPrice || 0)
                        }})
                      </mat-checkbox>
                    }
                  </div>
                </div>

                <!-- Right Column: overview card & next button -->
                <div class="step-side-col">
                  <div class="step-card step-card-sidebar">
                    <div class="titles">{{ 'buy.overview' | translate }}</div>
                    <div class="amounts">
                      <div class="amount">
                        @if (this.formStep1.value.amount === 1) {
                          {{ 'buy.step1.costsSingle' | translate }}
                        } @else {
                          {{ 'buy.step1.costs' | translate }}
                        }
                        <div class="spacing-flex"></div>
                        <div class="value">€{{ getCurrencyString(voucherTotal()) }}</div>
                      </div>
                      <div class="amount">
                        {{ 'buy.step1.administrationCosts' | translate }}
                        <div class="spacing-flex"></div>
                        <div class="value">€{{ getCurrencyString(this.voucherGroup().administrationCost) }}</div>
                      </div>
                      @if (this.formStep1.value.giftWrapping) {
                        <div class="amount">
                          {{ 'buy.step1.gift-wrapping' | translate }}
                          <div class="spacing-flex"></div>
                          <div class="value">€{{ getCurrencyString(giftWrappingTotal()) }}</div>
                        </div>
                      }
                      <hr />
                      <div class="amount primary">
                        {{ 'buy.step1.total' | translate }}
                        <div class="spacing-flex"></div>
                        <div class="value">€{{ getCurrencyString(totalPrice()) }}</div>
                      </div>
                    </div>
                    <div class="sidebar-buttons">
                      <button
                        mat-flat-button
                        (click)="stepForward()"
                        [disabled]="this.formStep1.invalid"
                        class="border-button"
                      >
                        {{ 'buy.button.next' | translate }}
                        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          }
          @if (step() === 2) {
            <form [formGroup]="formStep2" class="step" aria-label="{{ 'buy.aria.step2' | translate }}">
              <div class="step-header">
                <div class="step-header-text">
                  <div class="titles" id="step2Title">{{ 'buy.step2.header' | translate }}</div>
                </div>
                <div class="total-badge">
                  {{ 'buy.totalAmount' | translate }}
                  <span class="total-badge-value">€{{ getCurrencyString(totalPrice()) }}</span>
                </div>
              </div>

              <!-- Card 1: Type Bestelling -->
              <div class="step-card">
                <div class="titles">
                  <mat-icon style="color: var(--primary)">person</mat-icon>
                  {{ 'buy.step2.orderType' | translate }}
                </div>
                <mat-radio-group
                  formControlName="type"
                  class="custom-radio-group"
                  aria-label="{{ 'buy.aria.orderType' | translate }}"
                >
                  <mat-radio-button value="customer" class="custom-radio-button">
                    {{ 'buy.step2.private' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="company" class="custom-radio-button">
                    {{ 'buy.step2.company' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <!-- Card 2: Contactgegevens -->
              <div class="step-card">
                <div class="form-row">
                  @if (formStep2.value.type === 'company') {
                    <mat-form-field class="form-col">
                      <mat-label>{{ 'buy.step2.companyName' | translate }}</mat-label>
                      <input formControlName="companyName" matInput required autocomplete="organization" />
                      <mat-error>
                        {{ getError('companyName') }}
                      </mat-error>
                    </mat-form-field>
                  }
                  <mat-form-field class="form-col">
                    <mat-label>{{ 'input.name' | translate }}</mat-label>
                    <input formControlName="name" matInput required autocomplete="name" />
                    <mat-error>
                      {{ getError('name') }}
                    </mat-error>
                  </mat-form-field>
                  @if (formStep2.controls.phone) {
                    <mat-form-field class="form-col">
                      <mat-label>{{ 'input.phone' | translate }}</mat-label>
                      <input minlength="10" formControlName="phone" matInput required autocomplete="tel-national" />
                      <mat-error>
                        {{ getError('phone') }}
                      </mat-error>
                    </mat-form-field>
                  }
                </div>
              </div>

              <!-- Card 3: Factuuradres -->
              <div class="step-card">
                <div class="titles" id="step2Billing">
                  <mat-icon style="color: var(--primary)">description</mat-icon>
                  {{ 'buy.step2.billing' | translate }}
                </div>
                <div class="address-row-3">
                  <mat-form-field class="postal-col">
                    <mat-label>{{ 'input.postal' | translate }}</mat-label>
                    <input
                      formControlName="postal"
                      id="postal"
                      matInput
                      #postalCode
                      required
                      autocomplete="postal-code"
                      placeholder="1234AB"
                      (blur)="getAddress()"
                    />
                    @if (formStep2.controls.postal.hasError('apiError')) {
                      <mat-error>
                        {{ 'buy.step2.noAddressFound' | translate }}
                      </mat-error>
                    }
                    <mat-error>
                      {{ getError('postal') }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="number-col">
                    <mat-label>{{ 'input.houseNumber' | translate }}</mat-label>
                    <input formControlName="houseNumber" matInput required (blur)="getAddress()" />
                    <mat-error>
                      {{ getError('houseNumber') }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="addition-col">
                    <mat-label>{{ 'input.houseNumberAddition' | translate }}</mat-label>
                    <input formControlName="houseNumberAddition" matInput />
                    <mat-hint>{{ 'buy.optionalField' | translate }}</mat-hint>
                    <mat-error>
                      {{ getError('houseNumberAddition') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-row">
                  <mat-form-field class="form-col">
                    <mat-label>{{ 'input.street' | translate }}</mat-label>
                    <input formControlName="street" matInput required autocomplete="address-line1" />
                    <mat-error>
                      {{ getError('street') }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="form-col">
                    <mat-label>{{ 'input.city' | translate }}</mat-label>
                    <input formControlName="city" matInput required autocomplete="address-level2" />
                    <mat-error>
                      {{ getError('city') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Card 4: Afleveradres -->
              <div class="step-card">
                <div class="titles" id="step2Delivery">
                  <mat-icon style="color: var(--primary)">local_shipping</mat-icon>
                  {{ 'buy.step2.delivery' | translate }}
                </div>
                <mat-radio-group
                  formControlName="delivery"
                  class="custom-radio-group"
                  aria-label="{{ 'buy.aria.deliveryAddress' | translate }}"
                >
                  <mat-radio-button value="equalto" class="custom-radio-button">
                    {{ 'buy.step2.equal' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="differentfrom" class="custom-radio-button">
                    {{ 'buy.step2.different' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
                @if (formStep2.value.delivery === 'differentfrom') {
                  <div class="delivery-position">
                    <div class="address-row-3">
                      <mat-form-field class="postal-col">
                        <mat-label>{{ 'input.postal' | translate }}</mat-label>
                        <input
                          formControlName="deliveryPostal"
                          id="deliveryPostal"
                          matInput
                          #postalCode
                          required
                          autocomplete="postal-code"
                          placeholder="1234AB"
                          (blur)="getDeliveryAddress()"
                        />
                        @if (formStep2.controls.deliveryPostal.hasError('apiError')) {
                          <mat-error>
                            {{ 'buy.step2.noAddressFound' | translate }}
                          </mat-error>
                        }
                        <mat-error>
                          {{ getError('deliveryPostal') }}
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="number-col">
                        <mat-label>{{ 'input.houseNumber' | translate }}</mat-label>
                        <input formControlName="deliveryHouseNumber" matInput required (blur)="getDeliveryAddress()" />
                        <mat-error>
                          {{ getError('deliveryHouseNumber') }}
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="addition-col">
                        <mat-label>{{ 'input.houseNumberAddition' | translate }}</mat-label>
                        <input formControlName="deliveryHouseNumberAddition" matInput />
                        <mat-hint>{{ 'buy.optionalField' | translate }}</mat-hint>
                        <mat-error>
                          {{ getError('deliveryHouseNumberAddition') }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="form-row">
                      <mat-form-field class="form-col">
                        <mat-label>{{ 'input.street' | translate }}</mat-label>
                        <input formControlName="deliveryStreet" matInput required />
                        <mat-error>
                          {{ getError('deliveryStreet') }}
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="form-col">
                        <mat-label>{{ 'input.city' | translate }}</mat-label>
                        <input formControlName="deliveryCity" matInput required autocomplete="address-level2" />
                        <mat-error>
                          {{ getError('deliveryCity') }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                }
              </div>

              <!-- Card 5: Bevestiging bestelling -->
              <div class="step-card">
                <div class="titles" id="step2Confirmation">
                  <mat-icon style="color: var(--primary)">alternate_email</mat-icon>
                  {{ 'buy.step2.confirmation' | translate }}
                </div>
                <div class="form-row">
                  <mat-form-field class="formfield-width-100">
                    <mat-label>{{ 'input.email' | translate }}</mat-label>
                    <input
                      formControlName="email"
                      matInput
                      required
                      (keydown.space)="$event.preventDefault()"
                      autocomplete="email"
                      placeholder="info@voorbeeld.nl"
                    />
                    <mat-error>
                      {{ getError('email') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="buttons">
                <button mat-button (click)="stepBackward()" class="button-back" type="button">
                  <mat-icon>arrow_back</mat-icon> {{ 'buy.button.back' | translate }}
                </button>
                <div class="spacing-flex"></div>
                <button
                  class="border-button"
                  (click)="stepForward()"
                  [disabled]="this.formStep2.invalid"
                  mat-flat-button
                >
                  {{ 'buy.button.next' | translate }}
                  <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                </button>
              </div>
            </form>
          }
          @if (extraStepExists() && step() === 3) {
            <form [formGroup]="formStep3" class="step" aria-label="{{ 'buy.aria.step3' | translate }}">
              <div class="step-header">
                <div class="step-header-text">
                  <div class="titles" id="step3Title">
                    {{ 'buy.step3.header' | translate: { extraStepName: ('buy.step3.extra' | translate) } }}
                  </div>
                </div>
                <div class="total-badge">
                  {{ 'buy.totalAmount' | translate }}
                  <span class="total-badge-value">€{{ getCurrencyString(totalPrice()) }}</span>
                </div>
              </div>
              <div class="step-card">
                <div class="titles">{{ 'buy.step3.paperSlipPrint' | translate }}</div>
                <mat-form-field class="formfield-width-100">
                  <mat-label>
                    {{ 'buy.step3.personalMessage' | translate }}
                  </mat-label>
                  <textarea
                    formControlName="personalMessage"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="10"
                    cdkAutosizeMaxRows="10"
                  ></textarea>
                  <mat-hint>{{ 'buy.optionalField' | translate }}</mat-hint>
                </mat-form-field>
              </div>
              <div class="flex-buttons">
                <button mat-button (click)="stepBackward()" type="button" class="button-back">
                  <mat-icon>arrow_back</mat-icon> {{ 'buy.button.back' | translate }}
                </button>
                <div class="flex-spacer"></div>
                <button class="border-button" (click)="stepForward()" mat-flat-button>
                  {{ 'buy.button.next' | translate }}
                  <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                </button>
              </div>
            </form>
          }
          @if ((!extraStepExists() && step() === 3) || step() === 4) {
            <form [formGroup]="formStep4" class="step" aria-label="{{ 'buy.aria.step4' | translate }}">
              <div class="step-header">
                <div class="step-header-text">
                  @if (step() === 4) {
                    <div class="titles" id="step4Title">{{ 'buy.step4.headerStep4' | translate }}</div>
                  } @else {
                    <div class="titles" id="step4Title">{{ 'buy.step4.headerStep3' | translate }}</div>
                  }
                </div>
              </div>

              <div class="step-container">
                <!-- Left Column: conditions -->
                <div class="step-main-col">
                  <!-- Card 1: ACTIEVOORWAARDEN -->
                  @if (voucherGroup().terms) {
                    <div class="step-card">
                      <div class="titles">
                        <mat-icon style="color: var(--primary)">campaign</mat-icon>
                        {{ 'activate.body.conditions' | translate }}
                      </div>
                      <div class="textarea-positioning">
                        <mat-form-field class="textarea voucher-terms" [class.voucher-terms]="availableVouchers() > 0">
                          <textarea
                            aria-label="{{ 'buy.aria.conditions' | translate }}"
                            matInput
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="{{ this.termsRows() }}"
                            cdkAutosizeMaxRows="{{ this.termsRows() }}"
                            disabled="true"
                            value="{{ voucherGroup().terms }}"
                            readonly
                          ></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  }

                  <!-- Card 2: ALGEMENE VOORWAARDEN -->
                  <div class="step-card">
                    <div class="titles">
                      <mat-icon style="color: var(--primary)">description</mat-icon>
                      {{ 'terms.heading' | translate }}
                    </div>
                    <a class="terms-link" [href]="termsUrl()" target="_blank" rel="noopener noreferrer">
                      {{ 'terms.general' | translate }}
                    </a>
                    <a class="terms-link" [href]="privacyUrl()" target="_blank" rel="noopener noreferrer">
                      {{ 'terms.privacy' | translate }}
                    </a>
                  </div>
                </div>

                <!-- Right Column: Overview and checkbox -->
                <div class="step-side-col">
                  <!-- Card 3: Overzicht -->
                  <div class="step-card">
                    <div class="titles">
                      <mat-icon style="color: var(--primary)">shopping_bag</mat-icon>
                      {{ 'buy.overview' | translate }}
                    </div>
                    <div class="amounts">
                      <div class="amount primary">
                        @if (this.formStep1.value.amount === 1) {
                          {{ 'buy.step4.buyAmountSingle' | translate: { value: this.formStep1.value.amount } }}
                        } @else {
                          {{ 'buy.step4.buyAmount' | translate: { value: this.formStep1.value.amount } }}
                        }
                      </div>
                      <div class="amount">
                        @if (this.formStep1.value.amount === 1) {
                          {{ 'buy.step1.costsSingle' | translate }}
                        } @else {
                          {{ 'buy.step1.costs' | translate }}
                        }
                        <div class="spacing-flex"></div>
                        <div class="value">€{{ getCurrencyString(voucherTotal()) }}</div>
                      </div>
                      <div class="amount">
                        {{ 'buy.step1.administrationCosts' | translate }}
                        <div class="spacing-flex"></div>
                        <div class="value">€{{ getCurrencyString(this.voucherGroup().administrationCost) }}</div>
                      </div>
                      @if (this.formStep1.value.giftWrapping && this.voucherGroup().sellType === 'physical') {
                        <div class="amount">
                          {{ 'buy.step1.gift-wrapping' | translate }}
                          <div class="spacing-flex"></div>
                          <div class="value">€{{ getCurrencyString(giftWrappingTotal()) }}</div>
                        </div>
                      }
                      <hr />
                      <div class="amount primary">
                        {{ 'buy.step1.total' | translate }}
                        <div class="spacing-flex"></div>
                        <div class="value">€{{ getCurrencyString(totalPrice()) }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="terms-checkbox-container">
                    <mat-checkbox class="terms-checkbox" formControlName="terms">
                      {{ 'buy.step4.acceptTerms' | translate }}
                    </mat-checkbox>
                  </div>
                </div>
              </div>

              <div class="buttons">
                <button
                  mat-button
                  (click)="stepBackward()"
                  class="button-back"
                  type="button"
                  [disabled]="awaitingResponse()"
                >
                  <mat-icon>arrow_back</mat-icon> {{ 'buy.button.back' | translate }}
                </button>
                <div class="spacing-flex"></div>
                <button
                  [class.spinner]="awaitingResponse()"
                  mat-flat-button
                  [disabled]="!formStep4.valid || awaitingResponse()"
                  (click)="submit()"
                  class="border-button"
                >
                  {{ 'buy.button.pay' | translate }}
                </button>
              </div>
            </form>
          }
        </div>
      }
    </div>
  } @else if (campaignInactive()) {
    <div class="activate-card">
      @if (townshipImage()) {
        <div class="imgWrapper">
          <img [src]="townshipImage()" alt="logo" class="logo" />
        </div>
      }
      <p class="title">Het bestellen van bonnen is niet meer mogelijk omdat deze campagne niet actief is.</p>
    </div>
  } @else {
    <div class="loading-wrapper">
      <div class="loading">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  }
</div>
